import React, { Suspense, useEffect } from "react";
import { createTheme, ThemeProvider, Def } from "@mui/material";
import Toastify from "./components/toastify/Tostify";
import Navigation from "./navigation/navigation";
import NavBar from "./components/navigation-bar/NavBar";
import Spinner from "./components/Spinner";
import firebase from "./utils/firebase";
import { whizzAppStore } from "./redux/store";
import { BrowserRouter as Router } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { useDispatch, Provider, useSelector } from "react-redux";
import { loginSuccess, logoutSuccess } from "./redux/reducers/auth.reducer";
import {
  clearSelectedEmirates,
  clearSelectedRegion,
} from "./redux/reducers/emiratesAndRegion.reducer";
import { setSelectedStores } from "./redux/reducers/stores.reducer";
import {
  setSelectedEmirates,
  setSelectedRegion,
} from "./redux/reducers/emiratesAndRegion.reducer";
import ProductCard from "./components/products/ProductCard";
import { setFavouriteProducts } from "./redux/reducers/favouriteProducts.reducer";
import { setMessagesCount } from "./redux/reducers/messages.reduce";
import {
  setNotifications,
  setNotificationsProducts,
} from "./redux/reducers/notificationsProducts.reducer";
import FullScreenLoading from "./components/FullScreenLoading";
import { algoliaClient } from "./utils/constants";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import { toast as Toast } from "react-toastify";
import { isMobile } from "react-device-detect";
import CompleteProfileHint from "./components/CompleteProfileHint";
import ResponsiveNewDrawer from "./components/navigation-bar/responsive-drawer";
export const themeOptions = {
  palette: {
    type: "light",
    primary: {
      main: "#fac904",
    },
    secondary: {
      main: "#FC3C3C",
    },
    error: {
      main: "#FC3C3C",
    },
    warning: {
      main: "#FFBB33",
    },
    info: {
      main: "#362d27",
    },
  },
  light: {
    primary: "#fac904",
    accent: "#95AEE0",
    warning: "#FFBB33",
    secondary: "#FC3C3C",
    white: "#fff",
    success: "#66bb6a",
    dark: "#774e1e",
    rgbPrimaryLight: "rgba(250, 201, 4,##)",
  },
  dark: {
    primary: "#e49314",
    accent: "#95AEE0",
    warning: "#FFBB33",
    secondary: "#FC3C3C",
    white: "#fff",
    success: "#66bb6a",
    dark: "#362d27",
    rgbPrimaryLight: "rgba(250, 201, 4,##)",
  },
};

const theme = createTheme(themeOptions);

const App = () => {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.auth.user);
  const [searchMode, setSearchMode] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = React.useState(
    isMobile ? false : true
  );
  const searchValue = useSelector((state) => state.searchMode.text);
  const productsIndex = algoliaClient.initIndex("products");

  React.useEffect(() => {
    firebase.auth().onAuthStateChanged(async (currentUser) => {
      console.log("currrent user 1: ", currentUser);
      if (currentUser && !currentUser.isAnonymous) {
        console.log("currrent user : ", currentUser);
        const userInfo = await firebase
          .firestore()
          .collection("users")
          .doc(currentUser.uid)
          .get();
        if (userInfo.exists) {
          dispatch(loginSuccess(userInfo.data()));
          const stores =
            userInfo.data()?.stores && Array.isArray(userInfo.data()?.stores)
              ? userInfo.data()?.stores
              : [];
          if (userInfo?.data() && userInfo.data().emirates) {
            dispatch(setSelectedEmirates(userInfo.data().emirates ?? []));
          }
          if (userInfo?.data() && userInfo.data().areas) {
            dispatch(setSelectedRegion(userInfo.data().areas ?? []));
          }
          if (userInfo?.data() && userInfo.data().favourites) {
            dispatch(setFavouriteProducts(userInfo.data().favourites ?? []));
          } else {
            dispatch(setFavouriteProducts([]));
          }
          if (userInfo?.data() && userInfo.data().notifications) {
            dispatch(
              setNotificationsProducts(userInfo.data().notifications ?? [])
            );
            // setUserNotificationProducts(userInfo.data().notifications);
          } else {
            dispatch(setNotificationsProducts([]));
            //setUserNotificationProducts([]);
          }
          dispatch(setSelectedStores(stores));
        } else {
          await firebase
            .firestore()
            .collection("users")
            .doc(currentUser.uid)
            .set(
              {
                uid: currentUser.uid,
                fullName: currentUser.displayName,
                email: currentUser.email,
                profileImage: currentUser.photoURL,
                phone: currentUser.phoneNumber,
                providerId: currentUser?.providerData[0].providerId
                  ? currentUser?.providerData[0].providerId
                  : currentUser?.providerId,
              },
              { merge: true }
            )
            .then(() => {
              dispatch(
                loginSuccess({
                  uid: currentUser.uid,
                  fullName: currentUser.displayName,
                  email: currentUser.email,
                  profileImage: currentUser.photoURL,
                  providerId: currentUser?.providerData[0].providerId
                    ? currentUser?.providerData[0].providerId
                    : currentUser?.providerId,
                  isAnonymous: false,
                })
              );
              console.log("logged in");
            });
        }
      } else if (currentUser && currentUser.isAnonymous) {
        dispatch(
          loginSuccess({
            id: currentUser?.uid,
            email: currentUser?.email ?? "",
            accessType: currentUser?.providerData[0]?.providerId ?? "email",
            fullName: currentUser?.displayName ?? "",
            phone: currentUser?.phoneNumber ?? "",
            profileImage: currentUser?.photoURL ?? "",
            isAnonymous: true,
          })
        );
        console.log("logged in");
      } else {
        dispatch(logoutSuccess());
        localStorage.clear();
      }
    });
  }, []);

  useEffect(() => {
    if (userData && userData?.id) {
      // const notificationsSubscriber =firebase.firestore().collection("notifications").where("userId","==",userData?.id).orderBy("createdAt","desc").onSnapshot(snapshot =>{
      const notificationsSubscriber = firebase
        .firestore()
        .collection("notifications")
        .where("userId", "==", userData?.id)
        .onSnapshot((snapshot) => {
          if (snapshot.docs && snapshot.docs.length > 0) {
            const notificationsList = snapshot.docs.map((notification) =>
              notification.data()
            );
            dispatch(setNotifications(notificationsList));
          }
        });
      return () => notificationsSubscriber();
    }
  }, [userData]);

  useEffect(() => {
    if (userData && userData?.id) {
      const supportMsgsSubscriber = firebase
        .firestore()
        .collection("support-messages")
        .doc(userData.id)
        .onSnapshot((snapshot) => {
          if (snapshot.exists) {
            const counter = snapshot.data();
            if (!!counter.userUnreadCounter) {
              dispatch(setMessagesCount(counter.userUnreadCounter));
            } else {
              dispatch(setMessagesCount(0));
            }
          } else {
            dispatch(setMessagesCount(0));
          }
        });
      return () => supportMsgsSubscriber();
    } else {
      dispatch(setMessagesCount(0));
    }
  }, [userData]);

  React.useEffect(() => {
    if (!!searchValue && searchValue != "" && searchValue.length) {
      // get algolia records
      loadDataFromAlgolia();
    }
    return () => {
      setSearchMode([]);
    };
  }, [searchValue]);

  const loadDataFromAlgolia = () => {
    setLoading(true);
    productsIndex
      .search(searchValue, {
        maxFacetHits: 5,
      })
      .then((results) => {
        setSearchMode(results.hits);
        setLoading(false);
      })
      .catch((err) => {
        Toast.error(
          "Could not retrieve any search records, Please try again later."
        );
        setLoading(false);
      });
  };

  return (
    <React.Fragment>
      <ThemeProvider theme={theme}>
        <Router>
          {userData ? (
            <ResponsiveNewDrawer>
              <Suspense fallback={<Spinner />}>
                <main>
                  {loading && <FullScreenLoading />}
                  <Container maxWidth="lg">
                    {!loading && userData && (
                      <CompleteProfileHint isDrawerOpen={isDrawerOpen} />
                    )}
                    {!loading && searchMode && searchMode.length > 0 ? (
                      <Grid container spacing={12}>
                        {searchMode.map((item, index) => (
                          <ProductCard
                            card={item}
                            key={index + "Card Product Home"}
                          />
                        ))}
                      </Grid>
                    ) : (
                      <Navigation />
                    )}
                  </Container>
                </main>
                <Toastify />
              </Suspense>
            </ResponsiveNewDrawer>
          ) : (
            <Suspense fallback={<Spinner />}>
              <main>
                {loading && <FullScreenLoading />}

                <Container maxWidth="md">
                  {!loading && userData && (
                    <CompleteProfileHint isDrawerOpen={isDrawerOpen} />
                  )}
                  {!loading && searchMode && searchMode.length > 0 ? (
                    <Grid container spacing={12}>
                      {searchMode.map((item, index) => (
                        <ProductCard
                          card={item}
                          key={index + "Card Product Home"}
                        />
                      ))}
                    </Grid>
                  ) : (
                    <Navigation />
                  )}
                </Container>
              </main>
              <Toastify />
            </Suspense>
          )}
        </Router>
      </ThemeProvider>
    </React.Fragment>
  );
};

export default App;
